import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { AccountingModal } from "../../../../components/modals/accountingModal";
import { setShowAccountingModal } from "../../../../redux/actions/reports/reportsAction";

export const AccountingEntryDetailsModal = () => {
  const { showAccountingDetails } = useSelector((state) => state.report);
  const dispatch = useDispatch();
  const category = Object.keys(showAccountingDetails).find(
    (key) => showAccountingDetails[key]
  );

  if (!category) return null;

  return (
    <AccountingModal
      category={category}
      toggle={() => {
        dispatch(setShowAccountingModal({ [category]: false }));
      }}
    />
  );
};
